import React, { createContext, useContext } from 'react';

import PropTypes from 'prop-types';

import { useEntitiesSalesOrderProperty } from '../../hooks/entities/selectors/sales-orders';
import { ChildrenPropType } from '../../prop-types/children';

const OrderNumberContext = createContext('');

export const useOrderNumberContext = () => useContext(OrderNumberContext);

const OrderNumberContextProvider = ({ children, salesOrderId }) => {
  const orderNumber = useEntitiesSalesOrderProperty(salesOrderId, 'orderNumber');

  return <OrderNumberContext.Provider value={orderNumber}>{children}</OrderNumberContext.Provider>;
};

export default OrderNumberContextProvider;

OrderNumberContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
  salesOrderId: PropTypes.string.isRequired,
};
